import find from 'lodash/find';
import { defineStore } from 'pinia'
import {axios} from "@dutypay/utilities";
import {to} from "await-to-js";
import {isEmpty} from "lodash";
import {toRaw} from 'vue'

export const useCompanyStore = defineStore('companyStore', {
    state: () => {
        return {
            selectedCompany: JSON.parse(localStorage.getItem("selectedCompany")) || {},
            companies: [],
            areCompaniesFetched: false
        }
    },
    getters: {
        hasCompanies: state => !isEmpty(toRaw(state.companies)),
        hasSelectedCompany: state => !isEmpty(toRaw(state.selectedCompany)),
    },
    actions: {
        async fetchCompanies() {
            try {
                this.selectedCompany = JSON.parse(localStorage.getItem("selectedCompany"))
            } catch {
                this.selectedCompany = {}
            }
            let err, companies;
            [err, companies] = await to(
                axios({
                    url: `${process.env.VUE_APP_API_DUTYPAY}/api/v0/my/companies/all`,
                    method: "GET",
                })
            );
            if (err) {
                this.companies = []
                throw err;
            }
            let companiesList = companies.data.companies;
            this.companies = companiesList;
            this.areCompaniesFetched = true;
            if (companiesList.length === 1) {
                this.selectedCompany = companiesList[0];
            }
            return companiesList;
        },
        setCompany(companyId) {
            let company = find(this.companies, (c) => {
                return (c.id === companyId);
            });
            if (company) {
                this.selectedCompany = company
                localStorage.setItem('selectedCompany', JSON.stringify(company));
            }
            return company;
        },
    }
})